<template>
	<section v-if="items.length" class="faq-section align-center">
		<div class="row faq">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div class="columns column12">
					<div class="collapse-container">
						<div v-for="(item, index) in items" :key="index" class="faq-item">
							<collapse
								:header="item.question"
								:content="item.answer"
								:expanded="activeCollapse === index"
								@click="setExpanded(index)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<slot name="bgimage" />
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});

const activeCollapse = ref(null);
const setExpanded = (index) => {
	if (activeCollapse.value === index) {
		activeCollapse.value = null;
	} else {
		activeCollapse.value = index;
	}
};
</script>

<style lang="scss" scoped>
.row.faq {
	max-width: 1100px;
	position: relative;
	z-index: 3;
}

.collapse-container {
	background: var(--secondary-background-color);
}

.faq-section {
	position: relative;

	h2 {
		margin-bottom: 50px;
	}

	&.has-bgimage {
		&::after {
			display: block;
			position: absolute;
			content: '';
			inset: 0;
			z-index: 2;
			background: #000000ad;
		}

		h2 {
			color: #fff;
		}
	}
}
</style>
